<template>
  <ProfileForm
    v-bind="$props"
    @form-submit="handleSubmit"
    @click="$emit('click', $event)"
    @event="$emit('event', $event)"
  />
</template>

<script>
import { toRefs } from '@nuxtjs/composition-api';
import { ProfileForm } from '@campsite-bio/component-lib';

export default {
  components: {
    ProfileForm,
  },

  props: {
    link: {
      type: Object,
      required: true,
    },

    enableUtmParameters: {
      type: Boolean,
      default: false,
    },

    utmMedium: String,
    utmSource: String,
    imageSize: String,
    imageStyle: String,
    btnSize: String,
    variant: String,
  },

  setup(props, { emit }) {
    const { link } = toRefs(props);

    async function handleSubmit() {
      emit('event', 'form-submit');
    }

    return {
      id: link.value._id.$oid,
      handleSubmit,
    };
  },
};
</script>

<style lang="scss" scoped></style>
